import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'
import { H4, H6, Body1 } from '@components/Text'
import { Card as YogaCard } from '@gympass/yoga'

export const Card = styled(YogaCard)`
  padding: 40px;
  margin-top: 56px;
  margin-bottom: 72px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 104px;
  }
`

export const CardHeader = styled(YogaCard.Header)`
  margin-bottom: 24px;
`

export const CardTitle = styled(H4)`
  font-weight: 500;
  line-height: 23px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 24px;
    line-height: 29px;
  }
`

export const CardRow = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`
export const Description = styled(Body1)`
  font-style: normal;
  font-weight: normal;
  line-height: 16px;
  color: ${tokens.colors.deep};

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-transform: capitalize;
    align-self: flex-start;
  }
`

export const Value = styled(Body1)(
  () => `
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`
)

export const DividerWrapper = styled.section`
  margin-top: 24px;
  margin-bottom: 24px;
`

export const TotalWrapper = styled(H6)`
  font-weight: normal;

  em {
    text-decoration: none;
    font-style: normal;
  }

  span {
    margin-left: 2px;
    font-size: 24px;
    font-weight: 500;
  }
`
